import { useEffect, useState } from 'react';
const api = 'https://todo-backend-cg1o.onrender.com';

function App() {
  const [todos, setTodos] = useState([]);
  const [popupActive, setPopupActive] = useState(false);
  const [popup,setPopup]=useState(false)
  const [newTodo, setNewTodo] = useState('');
  useEffect(() => {
    GetTodos();
  }, []);

  const GetTodos = () => {
    fetch(api + '/todo')
      .then((res) => res.json())
      .then((data) => setTodos(data))
      .catch((err) => console.error('Error: ', err));
  };

  const completeTodo = async (id) => {
    const data = await fetch(api + '/todo/' + id).then((res) => res.json());

    setTodos((todos) =>
      todos.map((todo) => {
        if (todo._id === data._id) {
          todo.complete = data.complete;
        }

        return todo;
      })
    );
  };

  const addTodo = async () => {
    const data = await fetch(api + '/todo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        text: newTodo,
      }),
    }).then((res) => res.json());

    setTodos([...todos, data]);

    setPopupActive(false);

    setNewTodo('');
  };

  const deleteTodo = async (id) => {
    const data = await fetch(api + '/todo/' + id, { method: 'DELETE' }).then(
      (res) => res.json()
    );

    setTodos((todos) => todos.filter((todo) => todo._id !== data.result._id));
  };




  return (
    <div className='App'>
      <h1>Welcome, Yatheswar </h1>

      <h4>your tasks</h4>

      <div className='todos'>
        {todos.length > 0 ? (
          todos.map((todo) => (
            <div
              className={'todo' + (todo.complete ? ' is-complete' : '')}
              key={todo._id}
              onClick={() => completeTodo(todo._id)}
            >
              <div className='checkbox'></div>

              <div className='text'>{todo.text}</div>
              
              <div className='delete-todo' onClick={() => deleteTodo(todo._id)}>
                x
              </div>
            </div>
          ))
        ) : (
          <p>You currently have no tasks</p>
        )}
      </div>

      <div className='addPopup' onClick={() => setPopupActive(true)}>
        +
      </div>

      {popupActive ? (
        <div className='popup'>
          <div className='closePopup' onClick={() => setPopupActive(false)}>
            X
          </div>
          <div className='content'>
            <h3>Add Task</h3>
            <input
              type='text'
              className='add-todo-input'
              onChange={(e) => setNewTodo(e.target.value)}
              value={newTodo}
            />
            <div className='button' onClick={addTodo}>
              Create Task
            </div>
          </div>
        </div>
      ) : (
        ''
      )}   

      
    </div>
  );
}

export default App;
